import React from "react";

const UploadImage = props => {
	const { handleUploadImage, type, children } = props;
	return (
		<React.Fragment>
			<input
				type="file"
				hidden
				onChange={e => {
					handleUploadImage(e, type);
				}}
				id={type}
				multiple={false}
				accept="image/*"
				capture="environment"
			/>
			<label htmlFor={type}>{children}</label>
		</React.Fragment>
	);
};

export default UploadImage;
